export default __webpack_public_path__ + "static/media/actress.cf9b9b30.png";